import VueRouter from 'vue-router';
import Auth from './services/auth';

// Pages
import App from './layout/app.vue';
import Promocao from './pages/external/promo-bolt.vue';
import MissingCompany from './pages/external/missing-company.vue';
import PromoTollTicket from './pages/external/promo/promo-toll-ticket.vue';
import Login from './pages/auth/login.vue';
import PasswordRequest from './pages/auth/password-request.vue';
import PasswordSet from './pages/auth/password-set.vue';
import passwordChangeConfirmation from './pages/auth/password-change-confirmation.vue';
import TwoFAInterno from './pages/auth/2fa-interno.vue';
import PasswordChange from './pages/auth/password-change.vue';
import userContactsChange from './pages/auth/user-contacts-change.vue';
import ChooseChannel from './pages/auth/choose-channel.vue';
import AuthEmailCnpjRequest from './pages/auth/auth-email-cnpj-req.vue';
import AuthEmailTelRequest from './pages/auth/auth-email-tel-req.vue';
import Plans from './pages/account/plans.vue';
import Profile from './pages/account/profile/profile.vue';
import Refund from './pages/account/refund.vue';
import Statement from './pages/account/statement.vue';
import Vehicles from './pages/account/vehicles.vue';
import VehiclesPtoP from './pages/account/vehicles-p-to-p.vue';
import Requests from './pages/account/request/requests.vue';
import ReprocessOrders from './pages/account/request/reprocess-orders.vue';
import RequestDetail from './pages/account/request/request-detail.vue';
import MyAccount from './pages/account/my-account.vue';
import HomeAccount from './pages/account/home-account.vue';
import NewContract from './pages/account/contract/new-contract.vue';
import MigrationPlan from './pages/account/contract/migration-plan.vue';
import TagActivate from './pages/account/tag-activate.vue';
import VehicleEdit from './pages/account/vehicle-edit.vue';
import Recharge from './pages/account/recharge/recharge.vue';
import AccessionMonthlyPayment from './pages/account/accession-monthlypayment.vue';
import InvoiceHistory from './pages/account/invoice-history.vue';
import VehicleMovement from './pages/account/vehicle/vehicle-movement.vue';
import ReplaceTag from './pages/account/replace-tag/replace-tag.vue';
import ResultActivateTag from './pages/account/result-activate-tag.vue';
import Routing from './pages/account/routing/routing.vue';
import Routes from './pages/account/routing/routes.vue';
import RouteDetail from './pages/account/routing/route-detail.vue';
import Notification from './pages/account/notification.vue';
import RntrcVinculation from './pages/account/rntrc/rntrc-vinculation.vue';
import RoutingTeste from './pages/account/routing/routing-teste.vue';
import TransferShipper from './pages/account/shipper/transfer-shipper.vue';
import TransferShipperVouchers from './pages/account/shipper/transfer-shipper-vouchers.vue';
import TransferShipperVoucherDetail from './pages/account/shipper/transfer-shipper-voucher-detail.vue';
import ValidarCartao from './pages/account/validar-cartao.vue';
import WithdrawallPoints from './pages/external/withdrawal-points.vue'

import TransferCredit from './pages/account/credit/transfer-credit.vue';
import TransferCreditReceipt from './pages/account/credit/transfer-credit-receipt.vue';
import ConveniadoVoucher from './pages/account/request/conveniado-voucher.vue';

import BuyCredit from './pages/account/toll-ticket/buy-credit.vue';
import TollTicket from './pages/account/toll-ticket/toll-ticket.vue';
import Accompaniment from './pages/account/toll-ticket/accompaniment.vue';
import MyTollTicket from './pages/account/toll-ticket/my-toll-ticket.vue';
import SummaryAccompaniment from './pages/account/toll-ticket/summary-accompaniment.vue';
import Receipt from './pages/account/toll-ticket/receipt.vue';
import ReceiptCredit from './pages/account/toll-ticket/receipt-credit.vue';
import BalanceStatement from './pages/account/toll-ticket/balance-statement.vue';
import StatementConsolidated from './pages/account/toll-ticket/statement-consolidated.vue';

import Home from './pages/external/home.vue';
import TwoFA from './pages/auth/2fa.vue';
import HotSite from './pages/common/hotsite/hotsite.vue';
import Proposal from './pages/external/proposal.vue';
import ForYou from './pages/external/for-you.vue';
import ForBusiness from './pages/external/for-business.vue';
import Services from './pages/external/services.vue';
import ServicesB2B from './pages/external/services-b2b.vue';
import ServicesB2C from './pages/external/services-b2c.vue';
import ServicesVPO from './pages/external/services-vpo.vue';
import ServicesSenff from './pages/external/services-senff.vue';
import PrepayB2B from './pages/external/services-b2b-prepay.vue';
import Range from './pages/external/range.vue';
import Guide from './pages/external/guide.vue';
import FAQ from './pages/external/faq.vue';
import MoveMais from './pages/external/move-mais.vue';
import Contact from './pages/external/contact.vue';
import ContactPartner from './pages/external/contact-partner.vue';
import Repom from './pages/external/repom-redirect.vue';
import Adhesion from './pages/external/adhesion.vue';
import ContractDetail from './pages/account/contract/contract-detail.vue';
import NewVehicle from './pages/account/vehicle/new-vehicle.vue';
import LoginAtendente from './pages/external/login-atendente.vue';
import CompanyData from './pages/common/adhesion/company-data.vue';
import RechargeValueB2B from './pages/external/recharge-value-b2b.vue';
import RechargeValueB2C from './pages/external/recharge-value-b2c.vue';
import PlanPrepayManual from './pages/external/plan-prepay-manual-b2c.vue';
import PlanPrepayAuto from './pages/external/plan-prepay-auto-b2c.vue';
import PlanMovepay from './pages/external/plan-movepay-b2c.vue';
import ParanaWay from './pages/external/parana-way.vue';
import AdhesionShipper from './pages/external/adhesion-shipper.vue';
import Ombudsman from './pages/external/ombudsman.vue';
import RetornoSenff from './pages/external/retorno-senff.vue';
import ReprocessOrder from './pages/account/reprocess-order.vue';
import ServicesSodre from './pages/external/services-sodre.vue';
import ServicesB2BSodre from './pages/external/services-b2b-sodre.vue';
import ServicesB2CSodre from './pages/external/services-b2c-sodre.vue';
import PlanPrepayAutoSodre from './pages/external/plan-prepay-auto-sodre.vue';
import LoginSSA from './pages/external/login-ssa.vue';

import Success from './pages/common/adhesion/success.vue';
import AggregateList from './pages/account/aggregate/aggregate-list.vue';
import RescueBalance from './pages/account/aggregate/rescue-balance.vue';
import VpMovementVehicle from './pages/account/aggregate/vp-vehicle-movement.vue'
import ChooseChannelInterno from './pages/auth/choose-channel-interno.vue';

import Extract from './pages/pdf/extract.vue'

// Rotas
const routes = [
  {
    path: '/', component: App, redirect: '/inicio',name:'inicio',
    children: [
      { name: 'hotsite', path: 'hotsite', component: HotSite },
      {name: 'footer-hotsite', path: '/footer-hotsite', component: HotSite},
      {name: 'login', path: 'login', component: Login, beforeEnter: Auth.checkUserLoggedGuard.bind(Auth)},
      {name: 'success', path: '/success', component: Success},
      {name: 'view-qrcode-pix', path: '/visualizar-qrcode-pix', component: Success, props: true},
      {name: 'request-proposal', path: 'solicitar-proposta', component: Proposal},
      {name: 'range', path: 'cobertura', component: Range},
      {path: '/vale-pedagio', component: PromoTollTicket, name:'promo-toll-ticket'},
      {path: '/valepedagio', component: PromoTollTicket, name:'promo-toll-ticket'},
      {name: 'guide', path: 'guia-de-instalacao', component: Guide},
      {name: 'move-mais', path: 'move-mais', component: MoveMais},
      {name: 'home', path: 'inicio', component: Home},
      {name: '2fa', path: '2fa', component: TwoFA},
      {name: '2fa-login', path: 'login/2fa/:type', component: TwoFAInterno},
      {name: 'choose-channel-interno', path: 'choose-channel-interno', component: ChooseChannelInterno },

      {name: 'services', path: 'servicos', component: Services},
      {name: 'services-vpo', path: 'servicos-vpo', component: ServicesVPO},
      {name: 'services-b2b', path: 'servicos-b2b', component: ServicesB2B},
      {name: 'services-b2b-prepay', path: 'servicos-b2b-pre-pagos', component: PrepayB2B},
      {name: 'services-senff', path: 'servicos-senff', component: ServicesSenff},
      {name: 'services-b2c', path: 'servicos-b2c', component: ServicesB2C, props:{type: 'PF'}},
      {name: 'recharge-value-b2c', path: 'valores-recarga-b2c', component: RechargeValueB2C},
      {name: 'recharge-value-b2b', path: 'valores-recarga-b2b', component: RechargeValueB2B},
      {name: 'plan-prepay-manual-b2c', redirect: '/inicio', path: 'servicos-b2c-plano-controle', component: App},
      {name: 'plan-prepay-auto-b2c', redirect: '/inicio', path: 'servicos-b2c-plano-conforto', component: App},
      {name: 'plan-movepay-b2c', path: 'servicos-b2c-plano-move-e-pague', component: PlanMovepay, redirect: '/inicio'},
      {name: 'for-you', path: 'para-voce', component: ForYou},
      {name: 'for-business', path: 'para-empresas', component: ForBusiness},
      {name: 'contact', path: 'contato', component: Contact},
      {name: 'contact-partner', path: 'contato-parceiro', component: ContactPartner},
      {name: 'ombudsman', path: 'ouvidoria', component: Ombudsman},
      {name: 'FAQ', path: 'FAQ', component: FAQ},
      {name: 'password-request', path: 'autenticacao/requerer-senha/:type', component: PasswordRequest},
      {name: 'password-set', path: 'autenticacao/definir-senha/:type', component: PasswordSet},
      {name: 'choose-channel', path: 'autenticacao/escolher-canal/:type', component: ChooseChannel},
      {name: 'auth-email-cnpj-req', path: 'esqueci-email', component: AuthEmailCnpjRequest},
      {name: 'auth-email-tel-req', path: 'inserir-número-celular', component: AuthEmailTelRequest},
      {name: 'extract', path: 'pdf/extrato', component: Extract},
      {name: 'repom', path: 'repom', component: Repom},
      {name: 'adhesion', path: 'adesao', component: Adhesion, props: true},
      {name: 'login-atendente', path: 'login-atendente', component: LoginAtendente},
      {name: 'company-data', path: 'dados-empresa', component: CompanyData},
      {name: 'parana-way', path: 'caminhos-parana', component: ParanaWay},
      {name: 'rodosol', path: 'rodosol', component: Home},
      {name: 'adhesion-shipper', path: 'adesao-embarcador', component: AdhesionShipper, props: true},
      {name: 'services-sodre', path: 'sodre', component: ServicesSodre},
      {name: 'services-b2b-sodre', path: 'servicos-b2b-sodre', component: ServicesB2BSodre},
      {name: 'services-b2c-sodre', path: 'servicos-b2c-sodre', component: ServicesB2CSodre, props:{type: 'PF'}},
      {name: 'plan-prepay-auto-sodre',redirect: '/inicio', path: 'servicos-sodre-plano-conforto', component: App},
      {name: 'withdrawall-points', path: 'pontos-de-retirada', component: WithdrawallPoints},



      {
        path: 'conta', component: HomeAccount,

        beforeEnter: Auth.checkUserLoggedGuard.bind(Auth),
        children: [
          {name: 'plans', path: 'meus-planos', component: Plans, props: true },
          {name: 'profile', path: 'perfil', component: Profile},
          {name: 'password-change-confirmation', path: 'autenticacao/confirmar-troca', component: passwordChangeConfirmation},
          {name: '2fa-interno', path: 'autenticacao/2fa/:type', component: TwoFAInterno},
          {name: 'password-change', path: 'autenticacao/alterar-senha', component: PasswordChange},
          {name: 'user-contacts-change', path: 'contato/alterar-info/:type', component: userContactsChange},
          {name: 'buy-credit', path: 'comprar-credito', component: BuyCredit},
          {name: 'toll-ticket', path: 'vale-pedagio/:contractId', component: TollTicket},
          {name: 'accompaniment', path: 'acompanhamento/:contractId', component: Accompaniment},
          {name: 'my-toll-ticket', path: 'meus-vales-pedagio', component: MyTollTicket},
          {name: 'summary-accompaniment', path: 'resumo-acompanhamento/:contractId/:idVP', component: SummaryAccompaniment},
          {name: 'statement-consolidated', path: 'extrato-consolidado', component: StatementConsolidated},
          {name: 'receipt', path: 'comprovante-vale-pedagio/:contractId/:idVP', component: Receipt},
          {name: 'receipt-credit', path: 'comprovante-creditos/:orderId', component: ReceiptCredit},
          {name: 'balance-statement', path: 'saldo-extrato', component: BalanceStatement},
          {name: 'refund', path: 'contestacao', component: Refund},
          {
            name: 'contract-vehicles',
            path: 'contrato/:contractId/veiculos',
            component: Vehicles
          },
          {
            name: 'contract-vehicles-edit',
            path: 'contrato/:contractId/veiculo/:vehicleId',
            component: VehicleEdit
          },
          {
            name: 'vehicles-p-to-p',
            path: 'contrato/:contractId/veiculos/ponto-a-ponto',
            component: VehiclesPtoP
          },
          {
            name: 'contract-vehicles-new',
            path: 'contrato/:contractId/veiculos/novo',
            component: NewVehicle
          },
          {
            name: 'invoice-history',
            path: 'contrato/:contractId/faturas',
            component: InvoiceHistory
          },
          {
            name: 'contract-recharge',
            path: 'contrato/:contractId/:planId/recarregar',
            component: Recharge
          },

          {name: 'contract-statement', path: 'contrato/:contractId/:planId/extrato', component: Statement},
          {name: 'tag-activate', path: 'ativar-tag', component: TagActivate},
          {name: 'rntrc-vinculation', path: 'rntrc-vinculacao', component: RntrcVinculation},
          {name: 'notification', path: 'notification', component: Notification},
          {name: 'accession-monthlypayment', path: 'adesao-e-mensalidades', component: AccessionMonthlyPayment},
          {name: 'account-history', path: 'historico-de-contas', component: InvoiceHistory},
          {name: 'requests', path: 'meus-pedidos', component: Requests},
          {name: 'reprocess-orders', path: 'reprocessar-pedidos/:contractId', component: ReprocessOrders},
          {name: 'request-detail', path: 'detalhes/:orderId', component: RequestDetail},
          {
            name: 'vehicle-movement',
            path: 'contrato/:contractId/veiculo/:vehicleId/movimento',
            component: VehicleMovement
          },
          {name: 'replace-tag', path: 'substituicao-tag/:contractId/:vehicleId', component: ReplaceTag},
          {name: 'contract-detail', path: 'contrato/:contractId/detalhes', component: ContractDetail},
          {name: 'my-account', path: 'minha-conta', component: MyAccount},
          {name: 'new-contract', path: 'novo-contrato', props: true, component: NewContract},
          {name: 'migration-plan', path: 'migration-plan', props: true, component: MigrationPlan},
          {name: 'result-activate-tag', path: 'resumo-ativacao-tag/:plate/:serial', component: ResultActivateTag},
          {name: 'routing', path: 'rotas', component: Routing},
          {name: 'routes', path: 'rotas-embarcador', component: Routes},
          {name: 'route-detail', path: 'rota-detalhe/:routeId/:version', component: RouteDetail},
          {name: 'routing-teste', path: 'rotas-teste', component: RoutingTeste},
          {name: 'transfer-shipper', path: 'transferir-creditos/', props: true, component: TransferShipper},
          {name: 'transfer-shipper-vouchers', path: 'comprovantes-de-transferencias', component: TransferShipperVouchers},
          {name: 'transfer-shipper-voucher-detail', path: 'comprovante-da-transferencia', component: TransferShipperVoucherDetail},
          {name: 'reprocess-order', path: 'pagamento-pedido/:orderId', component: ReprocessOrder},
          {path: 'senff-retorno', component: RetornoSenff, name:'retorno-senff'},
          {path: 'transferir-creditos-pre-pago/:contractId', name: 'transfer-credit', component: TransferCredit },
          {path: 'comprovante-transferencia-credito/:orderId', name: 'transfer-credit-receipt', component: TransferCreditReceipt },
          {path: 'conveniado-voucher', name: 'conveniado-voucher', component: ConveniadoVoucher },
          {path: 'contrato/:contractId/:moveMaisId/agregados', name: 'aggregate-list', props: true, component: AggregateList},
          {path: 'resgatar-saldo/:contractId', name: 'rescue-balance', component: RescueBalance},
          {path: 'veiculo/movimentacao-vp', name: 'vp-vehicle-movement', component: VpMovementVehicle},
          {path: 'validar-cartao', name: 'validar-cartao', component: ValidarCartao },
        ]
      }
    ],
  },
  {path: '/promocao-relampago', component: Promocao, name:'promo-bolt'},
  {path: '/so-falta-sua-empresa', component: MissingCompany, name:'missing-company'},
  {path: '/vp', component: PromoTollTicket, name:'promo-toll-ticket'},
  {path: '/senff/retorno', component: RetornoSenff, name:'retorno-senff'},
  {path: '/ssa', component: LoginSSA, name:'login-ssa'},

];

// Roteador
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: 'active'
});

router.beforeEach(function (to, from, next) {
  $('body').stop().animate({scrollTop:0}, '500', 'swing');
  next();
});

router.afterEach((to, from) => {
  setTimeout(function(){
    $('[data-toggle="tooltip"]').tooltip();
  }, 3000);

  if(to.path.indexOf('/conta/') > -1 && $(window).width() < 767){
    setTimeout(()=>{$('footer').hide();}, 30);
  } else {
    setTimeout(()=>{$('footer').show();}, 30);
  }

  if (window.ga) window.ga('send', 'pageview', to.path);
});

export {router};



// WEBPACK FOOTER //
// ./src/routes.js